module.exports = __webpack_public_path__ + "f8f5baa6776f28ca9cb6b3b9b6879d1f.svg";